import { render, staticRenderFns } from "./InpatientEdit.vue?vue&type=template&id=09f72646&scoped=true"
import script from "./InpatientEdit.vue?vue&type=script&lang=js"
export * from "./InpatientEdit.vue?vue&type=script&lang=js"
import style0 from "./InpatientEdit.vue?vue&type=style&index=0&id=09f72646&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f72646",
  null
  
)

export default component.exports